import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-show-demos',
    templateUrl: './show-demos.component.html',
    styleUrls: ['./show-demos.component.scss'],
    standalone: false
})
export class ShowDemosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
